import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAdminAuthenticated, getAdminProfile, logoutAdmin } from '../services/adminApi';

// A wrapper component for routes that should be accessible only to authenticated users
export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        if (isAdminAuthenticated()) {
          // Verify token validity with backend
          const response = await getAdminProfile();
          if (response.success) {
            setAuthenticated(true);
          } else {
            // Token invalid or expired
            logoutAdmin();
            setAuthenticated(false);
          }
        } else {
          setAuthenticated(false);
        }
      } catch (error) {
        console.error('Authentication verification failed:', error);
        logoutAdmin();
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    verifyAuth();
  }, []);

  if (loading) {
    // You could show a loading spinner here
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  if (!authenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  return children;
} 